import { IonButton } from "@ionic/react";
import { useHistory } from "react-router-dom";

interface Props {
  setAccountError: Function;
  isDuplicateModal: boolean;
}

const AccountErrorModal: React.FC<Props> = ({
  setAccountError,
  isDuplicateModal,
}) => {
  let history = useHistory();

  return (
    <div className="overall-center-modal">
      <div className="generic-modal-main-wrap">
        <div className="icon-sec text-center">
          {isDuplicateModal ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="205"
              height="164"
              viewBox="0 0 205 164"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M112.369 116.591C112.369 91.1191 133.019 70.4697 158.491 70.4697C183.963 70.4697 204.613 91.1191 204.613 116.591C204.613 142.064 183.963 162.713 158.491 162.713C133.019 162.713 112.369 142.064 112.369 116.591ZM147.916 99.4925C146.115 97.6913 143.195 97.6913 141.394 99.4925C139.593 101.294 139.593 104.214 141.394 106.015L151.969 116.59L141.394 127.165C139.593 128.967 139.593 131.887 141.394 133.688C143.195 135.489 146.115 135.489 147.916 133.688L158.491 123.113L169.066 133.688C170.868 135.489 173.788 135.489 175.589 133.688C177.39 131.887 177.39 128.966 175.589 127.165L165.014 116.59L175.589 106.015C177.39 104.214 177.39 101.294 175.589 99.4925C173.788 97.6913 170.868 97.6913 169.067 99.4925L158.491 110.068L147.916 99.4925Z"
                fill="#802392"
              />
              <path
                d="M70.9907 0.867188C81.7495 0.867188 92.0677 5.14111 99.6753 12.7487C107.283 20.3563 111.557 30.6745 111.557 41.4333C111.557 52.1921 107.283 62.5103 99.6753 70.1179C92.0677 77.7255 81.7495 81.9994 70.9907 81.9994C60.2319 81.9994 49.9138 77.7255 42.3061 70.1179C34.6985 62.5103 30.4246 52.1921 30.4246 41.4333C30.4246 30.6745 34.6985 20.3563 42.3061 12.7487C49.9138 5.14111 60.2319 0.867188 70.9907 0.867188ZM56.5073 97.2117H85.4741C92.0027 97.2117 98.2778 98.3209 104.109 100.349C102.366 105.769 101.415 111.505 101.415 117.495C101.415 136.352 110.765 153.022 125.121 163.132H9.41261C4.21507 163.132 0 158.917 0 153.719C0 122.502 25.2904 97.2117 56.5073 97.2117Z"
                fill="#898989"
              />
            </svg>
          ) : (
            <svg
              width="200"
              height="160"
              viewBox="0 0 200 160"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M139.998 39.9993C139.998 58.499 127.467 74.0612 110.405 78.6236L59.9995 39.1243C60.4682 17.4372 78.1867 0 99.9988 0C122.092 0 139.998 17.9059 139.998 39.9993ZM82.5928 95.0921L164.154 159.341C163.091 159.778 161.935 159.997 160.716 159.997H39.2811C34.1562 159.997 30 155.841 30 150.716C30 120.998 53.2808 96.6858 82.5928 95.0921Z"
                fill="black"
              />
              <path
                d="M1.59548 2.87671C4.15793 -0.373237 8.8766 -0.966976 12.1265 1.59548L197.123 146.593C200.373 149.155 200.967 153.874 198.405 157.124C195.842 160.374 191.123 160.968 187.873 158.405L2.87671 13.4078C-0.373237 10.8453 -0.966976 6.12665 1.59548 2.87671Z"
                fill="#802392"
              />
            </svg>
          )}
        </div>
        <div className="generic-info-heading fw-600 text-center mb-16">
          Error
        </div>
        <div className="generic-info-desc  text-center fw-400 mb-32">
          {isDuplicateModal
            ? "Email address already associated with an account"
            : "Email address not on file. Try again with a different email or contact help desk."}
        </div>
        {isDuplicateModal ? (
          <div className="generic-modal-btn-wrap two-btns">
            <ul>
              <li>
                {" "}
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    setAccountError(false);
                  }}
                >
                  Retry
                </IonButton>
              </li>
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    setAccountError(false);
                    history.push("/login");
                  }}
                >
                  Login
                </IonButton>
              </li>
            </ul>
          </div>
        ) : (
          <div className="generic-modal-btn-wrap text-center">
            <IonButton
              className="generic-btn w-50"
              placeholder={undefined}
              onClick={() => {
                setAccountError(false);
              }}
            >
              OK
            </IonButton>
          </div>
        )}
      </div>
    </div>
  );
};
export default AccountErrorModal;
